// 專題 相關活動
import IndexEventComponent from "../basic/IndexEventComponent"; // 活動元件

const ProjectEvent = ({ t, events, locale }) => {
  return (
    <section className="w-full max-w-[680px] mx-auto pt-[40px] pb-[35px] text-center">
      <h4 className="text-h5 text-black pb-[34px]">{t("EVENT")}</h4>
      {/* 活動 */}
      <div className="space-y-[50px] usm:space-y-[30px]">
        {events?.map((v, i) => (
          <IndexEventComponent
            key={i + "project-event-list" + v?.id}
            locale={locale}
            t={t}
            event={v}
            className="w-full h-[396px] usm:mx-auto usm:aspect-[337/270] usm:max-w-[337px]"
          />
        ))}
      </div>
    </section>
  );
};

export default ProjectEvent;
